export default __webpack_public_path__ + "static/media/LONDON.de6528c6.jpg";